import styled from 'styled-components';

export const LoaderWrapper = styled.div``;
